'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _WidgetMessage2 = require('./WidgetMessage');

var _WidgetMessage3 = _interopRequireDefault(_WidgetMessage2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Representation of a request message
 *
 * @class
 * @extends {WidgetMessage}
 */
var WidgetRequest = function (_WidgetMessage) {
  (0, _inherits3.default)(WidgetRequest, _WidgetMessage);
  (0, _createClass3.default)(WidgetRequest, null, [{
    key: 'parse',

    /**
     * Parse an object literal or a JSON encoded string into a {@link WidgetResponse}
     * @method
     *
     * @param {{}|string} raw
     * @return {WidgetRequest}
     */
    value: function parse(raw) {
      var id = raw.id,
          widgetId = raw.widgetId,
          correlationId = raw.correlationId,
          body = raw.body;

      var parsedBody = typeof body === 'string' ? JSON.parse(body) : body;
      return new WidgetRequest({ id: id, widgetId: widgetId, correlationId: correlationId.toString(), body: parsedBody });
    }
  }]);

  /**
   * @param {String} id the message id
   * @param {String} widgetId the widget it
   * @param {String} correlationId the conversation id
   * @param {*} body the message body
   */
  function WidgetRequest(_ref) {
    var id = _ref.id,
        widgetId = _ref.widgetId,
        correlationId = _ref.correlationId,
        body = _ref.body;
    (0, _classCallCheck3.default)(this, WidgetRequest);
    return (0, _possibleConstructorReturn3.default)(this, (WidgetRequest.__proto__ || (0, _getPrototypeOf2.default)(WidgetRequest)).call(this, { id: id, widgetId: widgetId, correlationId: correlationId, body: body }));
  }

  return WidgetRequest;
}(_WidgetMessage3.default);

exports.default = WidgetRequest;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Widget/WidgetRequest.js
// module id = 98
// module chunks = 0